import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfTabSection from '@elem/ui/ef-tab-section';
import styles from './index.module.scss';
import Win3 from './Win3';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
export default function TheComp() {
    const { t } = useLang('theProduct.TabC');
    const listA = [
        {
            tabName: t('a_tab'),
            bottomContent: t('a_desc'),
            hadFooterBtn: true,
            footerBtnText: t('btn1'),
            footerBtnWinContent: <Win3 />,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724816138174/AC%20charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724816136641/AC%20charging%20(1).jpg',
            fixedElement: <EFXStream className="x-stream" color="#fff" />,
        },
        {
            tabName: t('b_tab'),
            bottomContent: t('b_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724816137372/Solar%20charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724816137105/Solar%20charging%20(1).jpg',
            hadFooterBtn: true,
            footerBtnText: t('btn1'),
            footerBtnWinContent: <Win3 />,
        },
        {
            tabName: t('c_tab'),
            bottomContent: t('c_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724816137648/Car%20charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724816137838/Car%20charging%20(1).jpg',
            hadFooterBtn: true,
            footerBtnText: t('btn1'),
            footerBtnWinContent: <Win3 />,
        },
        {
            tabName: t('d_tab'),
            bottomContent: t('d_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724816137161/Generator%20charging.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724816136808/Generator%20charging%20(1).jpg',
            hadFooterBtn: true,
            footerBtnText: t('btn1'),
            footerBtnWinContent: <Win3 />,
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('title')} title={t('label')} />
            <EfTabSection list={listA} gtm_list_name={t('title')} type="LROpacity" />
        </div>
    );
}
